import React, { useRef, useState } from "react";
import bgImg from "../../assets/bg-img.svg";
import blueTick from "../../assets/tick.svg";
import grayTick from "../../assets/gray-tick.svg";
import BasicDetailForm from "./BasicDetailForm";
import SocialDetails from "./SocialDetails";
import QuoteDetails from "./QuoteDetails";
import { baseUrl } from "../../utils/constants";
import Thankyou from "./Thankyou";
import { toast, ToastContainer } from "react-toastify";
import { addBasicDataValidation } from "../../utils/validation";
import { Link } from "react-router-dom";

const FormBody = () => {
  const [step, setStep] = useState(1);
  const [isRegistered, setIsRegistered] = useState(false);
  const [formData, setFormData] = useState({
    basicDetails: {},
    socialDetails: {},
    quoteDetails: {},
  });

  const nextStep = () => {
    if (step < 3) {
      setStep(step + 1);
    }
  };
  const prevStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (step === 1) {
      setFormData({
        ...formData,
        basicDetails: {
          ...formData.basicDetails,
          [name]: value,
        },
      });
    } else if (step === 2) {
      setFormData({
        ...formData,
        socialDetails: {
          ...formData.socialDetails,
          [name]: value,
        },
      });
    } else if (step === 3) {
      setFormData({
        ...formData,
        quoteDetails: {
          ...formData.quoteDetails,
          [name]: value,
        },
      });
    }
  };

  const notifyError = (error) => toast.error(error);
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataNew = new FormData();

    formDataNew.append("Name", formData.basicDetails.name);
    formDataNew.append("Username", formData.socialDetails.instagramUserName);
    formDataNew.append(
      "instagramProfile",
      formData.socialDetails.instagramProfileLink
    );
    formDataNew.append("Followers", formData.socialDetails.numberOfFollowers);
    formDataNew.append("Type", formData.socialDetails.type.value);
    formDataNew.append("Email", formData.basicDetails.email);
    formDataNew.append("contactNum", formData.basicDetails.mobile);
    formDataNew.append("whatsappNum", formData.basicDetails.whatsapp);
    formDataNew.append("password", formData.basicDetails.password);
    formDataNew.append("Quallity", null);
    formDataNew.append(
      "primaryCategory",
      formData.socialDetails.category.value
    );
    formDataNew.append("Gender", formData.basicDetails.gender.value);
    formDataNew.append("avgViews", formData.socialDetails.avgViews.value);
    formDataNew.append("Address", formData.basicDetails.address);
    formDataNew.append("pincode", formData.basicDetails.pincode);
    formDataNew.append("Location", formData.basicDetails.location);
    formDataNew.append("Commercials[reel]", formData.quoteDetails.reel);
    formDataNew.append("Commercials[post]", formData.quoteDetails.post);
    formDataNew.append("Commercials[story]", formData.quoteDetails.story);
    formDataNew.append("Youtube", formData.socialDetails.youtubeChannelLink);
    formDataNew.append(
      "YoutubeName",
      formData.socialDetails.youtubeChannelName
    );
    formDataNew.append("profilePic", formData.socialDetails.profilePic);
    formDataNew.append("uploadType", "creator signup");

    const requestOptions = {
      method: "POST",
      body: formDataNew,
    };

    try {
      const response = await fetch(
        `${baseUrl}/register-creators`,
        requestOptions
      );

      const responseData = await response.json();
      console.log(responseData);

      if (!response.ok) {
        notifyError(responseData.message || "Network response was not ok");
        throw new Error(responseData.message || "Network response was not ok");
      }

      setIsRegistered(true);
    } catch (error) {
      console.error("Error:", error);
      notifyError(error);
      setIsRegistered(false);
    }
  };

  const url = window.location.href;

  const boxWidth = useRef(null);

  return (
    <div className="container mt-4 main_container">
      <div className="row">
        <ToastContainer />
        <div className="col-md-5">
          <h1 className="heading">Influencer Details</h1>
          <div className="mt-3 img_box">
            <img src={bgImg} alt="bg" />
            <p className="mt-3">
              Let's start with the basics! Tell us a little about yourself to
              get the ball rolling - just the essentials so we can know who you
              are.
            </p>
            <p className="text-bold">
              {url.includes("/login") ? (
                <>
                  Don't have an account?{" "}
                  <Link className="login_link" to={"/signup"}>
                    Register
                  </Link>
                </>
              ) : (
                <>
                  Already Registered?{" "}
                  <Link className="login_link" to={"/login"}>
                    Login
                  </Link>
                </>
              )}
            </p>
          </div>
        </div>
        <div className="col-md-7">
          <div className="row">
            <div className="col-4">
              <div className="step_tracker">
                <img src={step > 1 ? blueTick : grayTick} alt="tick" />
                <p className="mb-0 ms-2">Basic Details</p>
              </div>
            </div>
            <div className="col-4">
              <div className="step_tracker">
                <img src={step > 2 ? blueTick : grayTick} alt="tick" />
                <p className="mb-0 ms-2">Social Media Details</p>
              </div>
            </div>
            <div className="col-4">
              <div className="step_tracker">
                <img src={!isRegistered ? grayTick : blueTick} alt="tick" />
                <p className="mb-0 ms-2">Quote Price</p>
              </div>
            </div>
          </div>
          <div className="form_box mt-3" ref={boxWidth}>
            {step === 1 && (
              <BasicDetailForm
                nextStep={nextStep}
                handleChange={handleChange}
                formData={formData.basicDetails}
                validation={addBasicDataValidation}
              />
            )}
            {step === 2 && (
              <SocialDetails
                nextStep={nextStep}
                prevStep={prevStep}
                handleChange={handleChange}
                formData={formData.socialDetails}
              />
            )}
            {step === 3 && !isRegistered && (
              <QuoteDetails
                nextStep={nextStep}
                prevStep={prevStep}
                handleChange={handleChange}
                formData={formData.quoteDetails}
                handleSubmit={handleSubmit}
              />
            )}
            {isRegistered && (
              <Thankyou
                width={boxWidth.current.clientWidth}
                height={boxWidth.current.clientHeight}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormBody;
